export default {
    LOGIN: 'auth/login',
    SIGNUP: 'auth/signup',
    OTPVERIFY: 'auth/otpVerify',
    RESENTOTP: 'auth/resentOtp',
    GETTEMPLATE: 'template/getTemplate',
    GETCATEGORY: 'category/getCategory',
    GETHEADINGCATEGORYLIST: 'category/getHeadingCategoryList',
    FORGOTPASSWORD: 'auth/forgotPassword',
    CHANGEPASSWORD: 'auth/changePassword',
    UPDATEPASSWORD: 'auth/updatePassword',
    GOOGLESIGNIN: 'auth/googleSignin',
    UPDATEUSER: "users/updateUser",
    GETTEMPLATEFORMDETAIL: 'template/getTemplateFormDetail',
    LOGINWITHMOBILE: 'auth/loginWithMobile',
    LOGINFORMOBILE: 'auth/loginForMobile',
    LOGINWITHOTP: 'auth/loginWithOtp',
    CHECKMOBILEEMAILSIGNUP: 'auth/checkMobileEmailSignup',
    VERIFYEMAILSIGNUP: 'auth/verifyEmailSignup',
    LOGINOTPVERIFYMOBILE: 'auth/loginOtpVerifyMobile',
    SIGNUPFORMOBILE: 'auth/signupForMobile',
    APPLESIGNIN: 'auth/appleSignin',
    GETUSERDETAIL: 'users/getUserDetail',
    CONTACTUSFORUSER: 'users/contactUsForUser',


    FAVOURITETHEMESTATUSUPDATE: "template/favouriteThemeStatusUpdate",
    ADDORDER: "orders/addOrder",
    GETORDERLIST: "orders/getOrderList",
    ORDERIMAGEUPLOAD: "orders/orderImageUpload",
    ORDERIMAGEDELETE: "orders/orderImageDelete",
    ADDREMOVEWISHLISTTEMPLATE: "template/addRemoveWishlistTemplate",
    GETWISHLISTTEMPLATE: "template/getWishlistTemplate",

    // plans
    GETPLAN: "plans/getPlan",
    GETSUGGESTDOMAINLIST: "domain/getSuggestDomainList",


    ORDERPAYMENT: "payment/orderPayment",
    PAYMENTORDER: "/payment/paymentOrder",
    PAYMENTORDERSUCCESS: "/payment/paymentOrderSuccess",
    GETPAYMENTDETAILS: "/payment/getPaymentDetails",
    GENRATEPAYMENTORDERID: "payment/genratePaymentOrderId",
    GETORDERDETAIL: "orders/getOrderDetail",
    ORDERDELETE: "orders/orderDelete",
    GETORDERSUBSCRIPTION: "payment/getOrderSubscription",
    GETUSERMESSAGELIST: "users/getUserMessageList",
    SWITCHTEMPLATE: "orders/switchTemplate",
    GETSUBSCRIPTIONDETAIL: "payment/getsubscriptiondetail",
    SEARCHTEMPLATE: "template/searchTemplate",
    GETORDERPAYMENTDETAIL: "payment/getOrderPaymentDetail",
    SUBSCRIPTIONSTATUSUPDATE: "payment/subscriptionStatusUpdate",
    GETNOTIFICATION: "notifications/getNotification",
    NOTIFICATIONSTATUSUPDATE: "notifications/notificationStatusUpdate",
    DELETEALLNOTIFICATION: "notifications/deleteAllNotification",

    
}